import { useTranslations } from 'next-intl'

import { Card } from '@/entities/contract'
import { Notice } from '@/shared/ui'

export const ProcessAnnouncement = () => {
  const t = useTranslations()

  return (
    <Card.Root spacing="large">
      <Card.Item>
        <Card.ItemTitle>
          {t('lease_request.lease_process_guide.title')}
        </Card.ItemTitle>
        <Card.ItemContent>
          <Notice.List gap={false}>
            <Notice.Item>
              {t.rich('lease_request.lease_process_guide_step', {
                strong: chunks => (
                  <span className="text-gray-900">{chunks}</span>
                ),
              })}
            </Notice.Item>
            <Notice.Item>
              {t(
                'lease_request.lease_process_guide_notice_landlord_response_within_24_hours',
              )}
            </Notice.Item>
            <Notice.Item>
              {t(
                'lease_request.lease_process_guide_notice_payment_confirms_lease',
              )}
            </Notice.Item>
          </Notice.List>
        </Card.ItemContent>
      </Card.Item>
    </Card.Root>
  )
}
